import React, { Component } from 'react'
import { ReactSpecimen } from 'catalog'
import '../static/widgets/sustainabilitywidget/sustainabilitywidget_css.css'
import './customOverrides.css'

class sustainabilityWidget extends Component {
  constructor (props) {
    super(props)
  }

  handleClick (e) {
    e.preventDefault()
  }

  render () {
    return (
      <ReactSpecimen noSource plain={true} responsive={['desktop', 'tablet portrait', 'mobile portrait']}>
        <div>
          {this.props.overlay &&
          <style dangerouslySetInnerHTML={{
            __html: `
              body { 
                height: 100vh;
                overflow-y: hidden;
              }
            `
          }} />
          }
          <link href="../widgets/sustainabilitywidget/sustainabilitywidget_css.css" rel="stylesheet" />

          <div className="sustainability-widget" data-playback-rate="0.75">
            <div id="sustainability-widget-start"></div>

            <div className="sustainability-widget__background">
              <div className="sustainability-widget__background-inner">
                <div className="sustainability-widget__video">
                  <video preload="auto" playsInline autoPlay loop muted>
                    <source src="../widgets/sustainabilitywidget/spinning-globe-960.mp4" type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>

            <section className="sustainability-widget__content">
              <h2>Our 1.5°C Future Plan</h2>

              <h3>Our actions</h3>

              <div className="sustainability-widget__content--actions">
                <a href="#action-1" onClick={(e => this.handleClick(e))}>
                  <div className="sustainability-widget__bubble" id="opportunity">
                    <h4>Opportunity</h4>
                    <p>Innovation for sustainable solutions</p>
                  </div>
                </a>

                <a href="#action-2" onClick={(e => this.handleClick(e))}>
                  <div className="sustainability-widget__bubble" id="leadership">
                    <h4>Leadership</h4>
                    <p>Science-based CO2 reduction targets</p>
                  </div>
                </a>

                <a href="#action-3" onClick={(e => this.handleClick(e))}>
                  <div className="sustainability-widget__bubble" id="risk">
                    <h4>Risk</h4>
                    <p>Access & integrate climate risk</p>
                  </div>
                </a>

                <div className="sustainability-widget__bubble-overlays">
                  <div className={this.props.overlay === 'action-1' ? 'sustainability-widget__overlay is-active' : 'sustainability-widget__overlay'} id="action-1">
                    <div className="sustainability-widget__overlay-inner">
                      <button type="button" className="icon icon--close"></button>
                      <div>
                        <h4>
                          <strong>Opportunity</strong>
                          Setting science-based CO2 reduction targets
                        </h4>
                        <p>
                          By signing the Business Ambition for 1.5°C pledge, Zurich recognizes the role the science-based targets play in
                          highlighting the decarbonization pathways necessary to meet the Paris Agreement per sector and translating these
                          into useful tools for companies. Currently, in the insurance sector, science-based targets do not exist for either
                          operations, insurance or investment portfolios. As part of the Business Ambition for 1.5°C, we have committed to
                          play an active role in changing that by developing and then setting our own ambitious targets. We advise the
                          <a href="https://www.zurich.com">Science Based Target initiative</a> on the methodology for financial services,
                          and took part in producing the <a href="https://www.zurich.com">CRO Forum report</a> on carbon foot-printing
                          methodology for underwriting portfolios. For further information, see our
                          <a href="https://www.zurich.com">environmental performance</a> and
                          <a href="https://www.zurich.com">investments pages</a>.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className={this.props.overlay === 'action-2' ? 'sustainability-widget__overlay is-active' : 'sustainability-widget__overlay'} id="action-2">
                    <div className="sustainability-widget__overlay-inner">
                      <button type="button" className="icon icon--close"></button>
                      <div>
                        <h4>
                          <strong>Leadership</strong>
                          Innovating for sustainable solutions
                        </h4>
                        <p>
                          We work with customers as well as public and private partners to enhance resilience and advocate for solutions to
                          prevent, or minimize, damage and harm from climate related perils. We develop insurance and risk management solutions
                          for new technologies, business models and approaches that will be required to achieve this unprecedented transition
                          to a climate neutral economy. We also use capital markets to search for – and fund – solutions to many of the pressing
                          social or environmental issues of our time. We have committed to making up to USD 5 billion in impact investments.
                          Achieving this level, will, we believe, avoid 5 million tons of CO2-equivalent emissions per year, and separately,
                          make a positive contribution to the lives and livelihoods of 5 million people. For further information, see our
                          <a href="https://www.zurich.com">insurance solutions</a> and
                          <a href="https://www.zurich.com">impact investment</a> pages.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className={this.props.overlay === 'action-3' ? 'sustainability-widget__overlay is-active' : 'sustainability-widget__overlay'} id="action-3">
                    <div className="sustainability-widget__overlay-inner">
                      <button type="button" className="icon icon--close"></button>
                      <div>
                        <h4>
                          <strong>Risk</strong>
                          Assess and integrate climate risks
                        </h4>
                        <p>
                          Zurich’s approach to managing climate risk is embedded within our multi-disciplinary Group-wide risk management processes.
                          As such, climate risk is managed in a consistent fashion to other risks to which the Group is exposed. We integrate
                          assessments of both physical and transition risks into our underwriting and investment strategies and this work will
                          only accelerate in the coming years as methodologies and new modeling tools are being developed. This goes much beyond
                          our <a href="https://www.zurich.com">disengagement and divestment position</a> from activities predominantly focused on
                          particularly carbon intense fossil fuels. For further information, see our <a href="https://www.zurich.com">TCFD disclosure page</a>.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="sustainability-widget__crossheading" id="crossheading">1.5°C</h3>

              <h3>Our goals</h3>

              <div className="sustainability-widget__content--goals">
                <div className="sustainability-widget__bubble" id="quality">
                  <h4>Quality</h4>
                  <p>Climate-risk optimised portfolios</p>
                </div>

                <div className="sustainability-widget__bubble" id="impact">
                  <h4>Impact</h4>
                  <p>Creating a brighter future together</p>
                </div>

                <div className="sustainability-widget__bubble" id="growth">
                  <h4>Growth</h4>
                  <p>Catalyse customer resilience & transition</p>
                </div>
              </div>
            </section>

            <div className="sustainability-widget__topics">
              <h2>Our 1.5°C Future Plan</h2>

              <ul>
                <li><a className="icon icon--mobile-nav-link alt" href="#governance" onClick={(e => this.handleClick(e))}>Governance</a></li>
                <li><a className="icon icon--mobile-nav-link alt" href="#metricstargets" onClick={(e => this.handleClick(e))}>Metrics & targets</a></li>
                <li><a className="icon icon--mobile-nav-link alt" href="#disclosure" onClick={(e => this.handleClick(e))}>Disclosure</a></li>
              </ul>
            </div>

            <div className="sustainability-widget__topic-overlays">
              <div className={this.props.overlay === 'governance' ? 'sustainability-widget__overlay is-active' : 'sustainability-widget__overlay'} id="governance">
                <div className="sustainability-widget__overlay-inner">
                  <button type="button" className="icon icon--close"></button>
                  <div>
                    <h4>Governance</h4>
                    <p>
                      The Governance, Nominations and Sustainability Committee’s (GNSC's) responsibilities and authorities include to review
                      and propose to the Board for approval targets on environmental, social and governance (ESG) matters which have a material
                      impact on business strategy, underwriting or business performance. This includes climate risks. Clear roles and responsibilities,
                      for both the Zurich Board of Directors and Zurich’s Executive Committee, ensure effective oversight and action of climate
                      change-related risks. For further information, see our <a href="https://www.zurich.com">TCFD disclosure</a> or
                      <a href="https://www.zurich.com">sustainability governance</a> page.
                    </p>
                  </div>
                </div>
              </div>

              <div className={this.props.overlay === 'metricstargets' ? 'sustainability-widget__overlay is-active' : 'sustainability-widget__overlay'} id="metricstargets">
                <div className="sustainability-widget__overlay-inner">
                  <button type="button" className="icon icon--close"></button>
                  <div>
                    <h4>Metrics & Targets</h4>
                    <p>
                      To ensure continuous improvement in our performance against our ambitious commitments, we have developed key performance
                      indicators (KPIs) for our focus areas. The metrics in place are designed to track the mitigation of operational and
                      investment related risks. We are also working on more long-term targets to achieve Our 1.5C Future Plan. For further
                      information, see our <a href="https://www.zurich.com">metrics & measurement</a> page.
                    </p>
                  </div>
                </div>
              </div>

              <div className={this.props.overlay === 'disclosure' ? 'sustainability-widget__overlay is-active' : 'sustainability-widget__overlay'} id="disclosure">
                <div className="sustainability-widget__overlay-inner">
                  <button type="button" className="icon icon--close"></button>
                  <div>
                    <h4>Disclosure</h4>
                    <p>
                      We have <a href="https://www.zurich.com">adopted</a> the recommendations of the Financial Stability Board’s Task force on
                      Climate Change-related Financial Disclosure (FSB-TCFD) and report on progress made in implementing the above commitments.
                      We are actively participating in a UNEP FI Insurance specific project to better understand climate risk and implement the
                      TCFD recommendations. For further information, see our <a href="https://www.zurich.com">TCFD disclosure</a> page.
                    </p>
                  </div>
                </div>
              </div>
            </div>


            <ul className="sustainability-widget__sidenav">
              <li class="sustainability-widget__sidenav_actions">
                Actions
                <ul>
                  <li><a href="#opportunity" onClick={(e => this.handleClick(e))}>Opportunity</a></li>
                  <li><a href="#leadership" onClick={(e => this.handleClick(e))}>Leadership</a></li>
                  <li><a href="#risk" onClick={(e => this.handleClick(e))}>Risk</a></li>
                </ul>
              </li>
              <li className="sustainability-widget__sidenav_crossheading">1.5°C</li>
              <li class="sustainability-widget__sidenav_goals">
                Goals
                <ul>
                  <li><a href="#quality" onClick={(e => this.handleClick(e))}>Quality</a></li>
                  <li><a href="#impact" onClick={(e => this.handleClick(e))}>Impact</a></li>
                  <li><a href="#growth" onClick={(e => this.handleClick(e))}>Growth</a></li>
                </ul>
              </li>
            </ul>

            <div id="sustainability-widget-end"></div>
          </div>
        </div>
      </ReactSpecimen>
    )
  }
}

export default sustainabilityWidget



// WEBPACK FOOTER //
// ./catalog/sustainabilityWidget/sustainabilityWidget.js